export default __webpack_public_path__ + "static/media/Decline-Button.dd0002ae.svg";